/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { formatNumber } from '@utils/utils'
import { replaceStringToElement } from '@utils/jsxutils'
import { PRICE_TYPE } from '@constants/index'
import * as _ from 'lodash'

// icon
import { GmoneyIco, ScashIco, HeartIco} from '@shared/Icon/MoneyIcon'
import Money1 from '@assets/images/icon/money_icon/money-01.png'
import Money2 from '@assets/images/icon/money_icon/money-02.png'
import Money3 from '@assets/images/icon/money_icon/money-03.png'
import Money4 from '@assets/images/icon/money_icon/money-04.png'
import Money5 from '@assets/images/icon/money_icon/money-05.png'
import Money6 from '@assets/images/icon/money_icon/money-06.png'
import Money7 from '@assets/images/icon/money_icon/money-07.png'
import PlusImg from '@assets/images/icon/etc_icon/plus-ico.png'
// css
import { ProductTrackItem } from '@store/shopStore'
import { ItemButton } from '../index.style'

interface ProductTrackProps {
  track: ProductTrackItem
  onClickTrack?: (id: number) => void
}

const ProductTrack: React.FC<ProductTrackProps> = (props: ProductTrackProps) => {
  const { track, onClickTrack } = props
  const { title, id, price_type } = track
  const titleLast = replaceStringToElement(title.replace('+', ''), 'G', <GmoneyIco/>)

  const getPriceImg = (priceType: PRICE_TYPE) => {
    switch (priceType) {
      case PRICE_TYPE.S_CASH:
        return <ScashIco/>
      case PRICE_TYPE.HEART:
        return <HeartIco/>
      default:
        return ''
    }
  }
  const priceImg = getPriceImg(price_type)

  const onClickItemButton = () => {
    onClickTrack(id)
  }

  // G머니 탭에 속한 아이템 ID
  const GmoneyItemId = [28, 29, 30, 31, 32, 33, 62, 63, 64, 65]

  let GmoneyImg
  switch (id) {
    case GmoneyItemId[0]:
      GmoneyImg = Money1
      break
    case GmoneyItemId[1]:
      GmoneyImg = Money2
      break
    case GmoneyItemId[2]:
      GmoneyImg = Money3
      break
    case GmoneyItemId[3]:
      GmoneyImg = Money4
      break
    case GmoneyItemId[4]:
      GmoneyImg = Money5
      break
    case GmoneyItemId[5]:
      GmoneyImg = Money6
      break
    case GmoneyItemId[6]:
      GmoneyImg = Money1
      break
    case GmoneyItemId[7]:
      GmoneyImg = Money3
      break
    case GmoneyItemId[8]:
      GmoneyImg = Money6
      break
    case GmoneyItemId[9]:
      GmoneyImg = Money7
      break
    default:
      GmoneyImg = Money1
      break
  }

  let ItemBtn
  if (_.includes(GmoneyItemId, id) ) {
    ItemBtn = (
      <Fragment>
        <div className="item-value">
          {titleLast}
        </div>

        <img src={GmoneyImg} alt="" className="money-img"/>

        <div className="item-skin">
          <img src={PlusImg} alt="추가 이미지" className="item-skin--plus"/>
          <img src={track.img_full} alt="스킨" className="item-skin--img"/>
          <span className="item-skin--name">스킨</span>
        </div>

        <div className="item-price">
          {formatNumber(track.price)} {priceImg}
        </div>
      </Fragment>
    )
  } else {
    ItemBtn = (
      <Fragment>
        <div className="item-value item">
          {track.name}
        </div>

        <img src={track.img_full} alt="아이템" className="item-img"/>

        <div className="item-price">
          {formatNumber(track.price)} {priceImg}
        </div>
      </Fragment>
    )
  }

  return (
    <ItemButton onClick={onClickItemButton}>
      {ItemBtn}
    </ItemButton>
  )
}

export default ProductTrack
